import { http } from '@/core/api';
import { executeRequest } from '@/core/either';
import type { ApiResult } from '@/core/either';
import type { CompanyInformation } from '@/types/CompanyInformationType';

export const companyService = {
  /**
   * Obtiene la información de identificación y dirección de la compañía.
   * @returns Promesa Either ApiResult<CompanyInformation>.
   */
  getCompanyInformation(): Promise<ApiResult<CompanyInformation>> {
    return executeRequest(() =>
      http.get<CompanyInformation>('company/b2b/identification-address')
    );
  },
};
